import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { quotationFiltersSchema } from './schemas';

export const quotationFiltersQueryOptions = queryOptions({
  queryKey: QueryKeys.quotations.index.filters,
  queryFn: async () => {
    const { data: filters } = await fetchJson('/quotations/filters', {
      schema: apiResourceSchema(quotationFiltersSchema),
    });

    return filters;
  },
  staleTime: 5 * 60 * 1000,
  gcTime: Infinity,
});

export const useQuotationFilters = () => {
  return useSuspenseQuery(quotationFiltersQueryOptions);
};
